import { createContext, useState } from 'react'
import { IFiltersSelected } from '../shared/components/Filters/Filters.model'
import { useTranslation } from 'react-i18next'
import { IProyectos } from '../shared/data/data.model'

const initialValue: any = {}

const FiltersContext = createContext<any>(initialValue)

export const FiltersProvider = ({ children }: any) => {
  const { t }: any = useTranslation()
  const [filterOpen, setFilterOpen] = useState('')

  const filterCategories = [
    { name: t('filters.categories.pais'), filterKey: 'country' },
    {
      name: t('filters.categories.state'),
      filterKey: 'state_or_province_or_region_or_department',
    },

    { name: t('filters.categories.bioma'), filterKey: 'bioma_or_region' },

    {
      name: t('filters.categories.companies'),
      filterKey: 'empresas',
    },
    { name: t('filters.categories.protected_area'), filterKey: 'area_overlap' },
    {
      name: t('filters.categories.community'),
      filterKey: 'community_overlap',
    },
  ]

  const [filtersSelected, setFiltersSelected] = useState<IFiltersSelected>({
    country: [{ label: t('filters.all'), value: t('filters.all') }],
    state_or_province_or_region_or_department: [
      { label: t('filters.all'), value: t('filters.all') },
    ],
    // id_territorio: [{ label: t('filters.all'), value: t('filters.all') }],
    bioma_or_region: [{ label: t('filters.all'), value: t('filters.all') }],
    amazonia: [{ label: t('filters.all'), value: t('filters.all') }],
    auditor: [{ label: t('filters.all'), value: t('filters.all') }],
    certificador: [{ label: t('filters.all'), value: t('filters.all') }],
    desarrolladora: [{ label: t('filters.all'), value: t('filters.all') }],
  })

  const [projectSelected, setProjectSelected] = useState<IProyectos>()

  return (
    <FiltersContext.Provider
      value={{
        filterCategories,
        filtersSelected,
        setFiltersSelected,
        projectSelected,
        setProjectSelected,
        filterOpen,
        setFilterOpen,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}

export default FiltersContext
